<template>
    <div class="w-full mb-2">
        <div class="w-full flex justify-between items-center">
            <div class="flex lg:flex-row flex-col">
                <strong>
                    Código de Barras {{ referenceComponent.barcode }}
                </strong>
            </div>
            <div class="flex">
                <small v-if="referenceComponent.updatedAt" class="text-center">
                    📆 {{ referenceComponent.updatedAt | date }}
                </small>

                <div v-if="deleteEnabled" id="actions" class="flex">
                    <app-button danger icon @click="remove">🗑</app-button>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap">
            <div
                v-if="reference.currentStock !== undefined"
                class="w-full my-2"
            >
                <span>
                    ⚠ La referencia ya esta en el inventario del tienda, este
                    proceso no realiza actualizaciones de inventario,
                    referencias y productos. Para actaualizar el inventario usa
                    el proceso de carga masiva de inventario.
                </span>
            </div>
            <div class="w-full mt-4 px-2">
                <price-offer-fields
                    v-model="prices"
                    :enabled="updateEnabled"
                    :current-price="currentValue('currentPrice')"
                    :current-price-offer="currentValue('currentPriceOffer')"
                    :current-cost="currentValue('currentCost')"
                    @blur="updateReference"
                />
            </div>

            <div class="w-full md:w-1/2 mt-6 px-2">
                <custom-input
                    v-model="referenceComponent.size"
                    label="Tamaño/Talla/Valor"
                    :disabled="!updateEnabled"
                    @blur="updateReference"
                />
                <div v-if="reference.currentSize !== undefined">
                    <span class="small">
                        <strong> Tamaño actual: </strong>
                        {{ reference.currentSize }}
                    </span>
                </div>
            </div>
            <div class="w-full md:w-1/2 mt-6 px-2">
                <color-input
                    v-model="color"
                    :enabled="updateEnabled"
                    @change="updateReference"
                />
                <div v-if="reference.currentSize !== undefined">
                    <span class="small">
                        <strong> Color actual: </strong>
                        {{ reference.currentColor }}
                    </span>
                </div>
            </div>
            <div
                v-if="stockEnabled && reference.stock !== undefined"
                class="w-full md:w-1/2 mt-6 px-2"
            >
                <custom-input
                    v-model="referenceComponent.stock"
                    type="number"
                    label="Stock"
                    :disabled="
                        !updateEnabled || reference.currentStock !== undefined
                    "
                    @blur="updateReference"
                />
                <div v-if="reference.currentStock !== undefined">
                    <span class="small">
                        <strong> Stock actual: </strong>
                        {{ reference.currentStock }}
                    </span>
                </div>
            </div>

            <images-manage
                :id="referenceComponent.barcode"
                v-model="referenceComponent.images"
                class="my-4"
                :enabled="updateEnabled"
                message="referencia"
                :default-alt="'Imagen de ' + referenceComponent.name"
                default-size="squareImage"
                :default-filters="{ size: 'squareImage' }"
                @change="updateReference"
            />
        </div>
    </div>
</template>

<script>
import { DEFAULT_IMAGE_URL } from "@/common/constants";

import ColorInput from "@/components/utils/ColorInput.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import ImagesManage from "@/components/utils/ImagesManage.vue";
import PriceOfferFields from "@/components/utils/PriceOfferFields.vue";

export default {
    name: "ReferenceSimpleManage",
    components: {
        ColorInput,
        ImagesManage,
        PriceOfferFields,
        CustomInput
    },
    props: {
        reference: {
            default: () => ({
                id: null,
                color: "blanco",
                colorRef: "#fff",
                cost: 30000,
                price: 50000,
                priceOffer: 40000,
                size: "unico",
                updatedAt: "2021-10-26T00:27:59.146Z",
                currentColor: "rubí",
                currentColorRef: "#e0115f",
                currentCost: 12000,
                currentPrice: 20000,
                currentPriceOffer: 20000,
                currentSize: "",
                images: [
                    {
                        alt: "alt",
                        id: 1,
                        sequence: { sequence: 1 },
                        url: DEFAULT_IMAGE_URL
                    }
                ]
            }),
            type: Object,
            required: true
        },
        updateEnabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        deleteEnabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        stockEnabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["update", "remove"],
    data: () => ({
        color: {
            color: "blanco",
            colorRef: "#fff"
        },
        referenceComponent: {
            id: null,
            barcode: "",
            color: "blanco",
            colorRef: "#fff",
            cost: 30000,
            price: 50000,
            priceOffer: 40000,
            size: "unico",
            updatedAt: "2021-10-26T00:27:59.146Z",
            images: [
                {
                    alt: "alt",
                    id: 1,
                    sequence: { sequence: 1 },
                    url: DEFAULT_IMAGE_URL
                }
            ]
        }
    }),
    computed: {
        prices: {
            get() {
                return {
                    price: this.referenceComponent.price,
                    priceOffer: this.referenceComponent.priceOffer,
                    cost: this.referenceComponent.cost
                };
            },
            set({ cost, price, priceOffer }) {
                this.referenceComponent = {
                    ...this.referenceComponent,
                    price,
                    priceOffer,
                    cost
                };
            }
        }
    },
    watch: {
        reference(value) {
            this.setValue(value);
        }
    },
    mounted() {
        this.setValue(this.reference);
    },
    methods: {
        currentValue(key) {
            const value = this.reference[key];
            return value === undefined || value === null ? null : value;
        },
        setValue(reference) {
            this.color = {
                color: reference.color,
                colorRef: reference.colorRef
            };
            this.referenceComponent = { ...reference };
        },
        updateReference() {
            this.$emit("update", { ...this.referenceComponent, ...this.color });
        },
        remove() {
            this.$emit("remove", { barcode: this.reference.barcode });
        }
    }
};
</script>
